// generated from 2_141 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const workflowLinkClickedFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("workflow_link_clicked_filter"),
  comparison_key: z.enum([
    "7", // 1_601 (74.78%)
    "8", // 540 (25.22%)
  ]),
  display_name: z.string(),
  // undefined: 968 (45.21%), defined 1_173 (54.79%)
  raw_value: z
    .object({
      prefilter_value: z.object({
        mc_id: common.objectId,
        mv_id: common.objectId,
        wf_id: common.objectId,
      }),
      value: z.object({
        link_id: common.objectId,
        // avg: 2183.46, min: 1, max: 19671
        short_id: z.int().min(1),
      }),
    })
    .optional(),
  value: z.object({
    id: z.object({
      link_id: common.objectId,
      // avg: 1479.53, min: 1, max: 19671
      short_id: z.int().min(1),
    }),
    pre_filter_value: z.object({
      id: z.object({
        mc_id: common.objectId,
        mv_id: common.objectId,
        wf_id: common.objectId,
      }),
      value: z.string(),
    }),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
